import { Select } from "@mantine/core";

const FilterValueSelector = ({ options, value, setValue, disabled, label, readOnly, nullable }) => {
  console.log(options);
  
  return (
    <Select
      data={options}
      value={value}
      onChange={(v) => setValue(v)}
      clearable={false}
      disabled={disabled}
      placeholder={label}
      required={!nullable}
      searchable
      readOnly={readOnly}
    />
  );
};

export default FilterValueSelector;
